import React from "react";

const StoreReqPurchaseSummary = ({
    selectedOutlet,
    companyName,
    panNumber,
    receivedDate,
    billNumber,
    formatSalesValue,
    subTotal,
    totalVat,
    discountAmount,
    setDiscountAmount,
    isComplementary,
    discount,
    grandTotal,
    navigate,
    deleteLoading,
    handleSubmit,
    submitLoading,
    rows
}) => {
    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
            <div className="flex flex-col md:flex-row gap-6 items-start justify-between">

                <div className="text-sm text-gray-600 space-y-1">
                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide border-b pb-2 mb-3">
                        Purchase details
                    </h3>
                    <div className="space-y-2.5 font-semibold">
                        <p><span className="text-gray-700">Outlet:</span> {selectedOutlet || '-'}</p>
                        {companyName && <p><span className="text-gray-700">Vendor:</span> {companyName}</p>}
                        {panNumber && <p><span className="text-gray-700">PAN:</span> {panNumber}</p>}
                        {receivedDate && <p><span className="text-gray-700">Received:</span> {receivedDate}</p>}
                        {billNumber && <p><span className="text-gray-700">Bill No:</span> {billNumber}</p>}
                    </div>
                </div>

                <div className="w-full md:w-72 text-sm">
                    <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide border-b pb-2 mb-3">
                        Order Summary
                    </h3>

                    <div className="space-y-2.5 font-semibold">
                        <div className="flex justify-between text-gray-700 text-sm">
                            <span>Subtotal:</span>
                            <span>{formatSalesValue(subTotal)}</span>
                        </div>
                        <div className="flex justify-between text-gray-700 text-sm">
                            <span>VAT (13%):</span>
                            <span>{formatSalesValue(totalVat)}</span>
                        </div>

                        <div className="flex items-center justify-between gap-3">
                            <label className="text-gray-700 whitespace-nowrap">Discount:</label>
                            <div className="flex items-center gap-1">
                                <span>−</span>
                                <input
                                    type="number"
                                    min="0"
                                    step="any"
                                    placeholder="0.00"
                                    value={discountAmount}
                                    disabled={isComplementary}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        if (val === "" || parseFloat(val) >= 0) setDiscountAmount(val);
                                    }}
                                    className="w-32 px-2 py-1 text-right text-sm border border-gray-200 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400"
                                />
                            </div>
                        </div>

                        {discount > 0 && (
                            <div className="flex justify-between text-red-600 text-sm">
                                <span>Applied Discount:</span>
                                <span>− {discount.toFixed(2)}</span>
                            </div>
                        )}

                        <div className="border-t pt-2 mt-2">
                            <div className="flex justify-between text-base text-gray-800">
                                <span>Grand Total:</span>
                                <span>{formatSalesValue(grandTotal)}</span>
                            </div>
                        </div>
                    </div>

                    <div className="flex gap-2 pt-2">
                        <button
                            onClick={() => {
                                navigate(-1);
                            }}
                            disabled={deleteLoading}
                            className="flex-1 py-2 border border-gray-200 text-gray-600 text-sm font-medium rounded-md hover:bg-gray-50 transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={() => handleSubmit(rows)}
                            disabled={submitLoading}
                            className="flex-1 py-2 bg-green-600 text-white text-sm font-medium rounded-md hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors flex items-center justify-center gap-1.5"
                        >
                            {submitLoading ? (
                                <><div className="h-3.5 w-3.5 border-2 border-white border-t-transparent rounded-full animate-spin" /> Submitting...</>
                            ) : "Receive"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StoreReqPurchaseSummary;